<template>
  <div>
    <div class="forgot-pass-box text-center">
      <div v-if="title" class="forgot-pwd-title">{{ title }}</div>
      <div v-else class="forgot-pwd-title" v-translate:pweb_title_input_activation_code="lang">
        Please input verification
      </div>
      <div class="forgot-pwd-wrapper">
        <p class="forgot-pwd-text">{{ helpText }}</p>
        <div class="input-verification form-group d-flex justify-content-between">
          <input v-model="otp[0]" type="text" maxlength="1" class="form-control" autofocus="true" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.focus()" required />
          <input v-model="otp[1]" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <input v-model="otp[2]" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <input v-model="otp[3]" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <input v-model="otp[4]" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.exact="$event.target.nextElementSibling.focus()" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
          <input v-model="otp[5]" type="text" maxlength="1" class="form-control" autocomplete="false" v-on:keyup.delete="$event.target.previousElementSibling.focus()" required />
        </div>
        <div class="text-center forgot-pwd-btn">
          <h6 v-if="eventType === 'verifyRegistrationPhoneNo' || eventType === 'verifyPhoneOtp' || (eventType === 'username' && this.phoneFlag == 'phone')" @click="$emit('onResendVerificationCode')" class="resend-otp-text-btn text-center cursor_pointer mb-20" v-translate:label_resend_code="lang">
            Resend Code
          </h6>
          <button class="btn btn-submit primary-bg" v-translate:rsb_submit="lang" @click="verifyOtp()">
            Submit
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Widget } from "@/components/services/participant-service";

export default {
  name: "auth-otp",
  props: ["title", "email", "lang", "eventType", "phoneFlag", "mobile"],
  computed: {
    ...mapGetters(["participant", "token", "pwebCognitoAuthentication"]),
    globalElements() {
      return this.$store.getters.getParticipantsPortalGlobalElements;
    },
    helpText() {
      return this.phoneFlag ? this.widget.translate("phone_verifiy_otp_description", "Please input the verification code that was sent to your phone.") : this.widget.translate("pweb_help_text_verify_otp", "Please input the verification code that was sent to your email.");
    }
  },
  data() {
    return {
      widget: new Widget(),
      otp: ["", "", "", "", "", ""]
    };
  },
  mounted() {
    this.$root.$on("onOtpResent", () => {
      this.otp = ["", "", "", "", "", ""];
    });
  },
  methods: {
    navigate(otp) {
      if (this.eventType == "username") {
        this.$emit("updateActiveScreen", {
          key: "selectStudy",
          flagKey: "createUsername",
          flagChild: "otp",
          flagValue: otp
        });
      } else if (this.eventType == "password" && this.pwebCognitoAuthentication) {
        this.$emit("updateActiveScreen", {
          key: "resetPassword",
          flagKey: "resetPassword",
          flagChild: "otp",
          flagValue: otp
        });
      } else if (this.eventType == "password") {
        this.$emit("updateActiveScreen", {
          key: "selectStudy",
          flagKey: "resetPassword",
          flagChild: "otp",
          flagValue: otp
        });
      }
    },
    verifyOtp() {
      const isValid = this.otp.filter(e => e !== "" && e !== null && e !== undefined);
      if (isValid.length == 6) {
        if (this.eventType == "verifyRegistrationPhoneNo" || this.eventType == "verifyPhoneOtp") {
          this.$emit("onSubmit", this.otp.join(""));
        } else {
          this.isOtpValid(this.otp.join("")).then(res => {
            if (res) {
              this.navigate(this.otp.join(""));
            }
          });
        }
      } else {
        const title = this.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
        this.$toastr.error(title);
      }
    },
    isOtpValid(otp) {
      const that = this;
      return new Promise((resolve, reject) => {
        if (otp && that.eventType == "password" && that.pwebCognitoAuthentication) {
          resolve(true);
        } else if (otp) {
          const verifyOtpPayload = {
            email: that.email,
            otp: otp,
            otpType: "CREATE_USERNAME_OTP",
            deviceType: "web"
          };
          if (this.phoneFlag == "phone") {
            delete verifyOtpPayload.email;
            verifyOtpPayload.mobile = this.mobile;
          }
          that.$api.ForgotUsernameOtpVerify(verifyOtpPayload).then(
            res => {
              if (res.data.errorCode == null) {
                resolve(true);
              } else {
                const title = that.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
                that.$toastr.error(title);
                reject(false);
              }
            },
            () => {
              const title = that.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
              that.$toastr.error(title);
              reject(false);
            }
          );
        } else {
          const title = that.widget.translate("OTP_NOT_VALIDATED", "Code not validated. Please validate your Code before resetting your password.");
          that.$toastr.error(title);
          reject(false);
        }
      });
    }
  }
};
</script>

<style scoped>
.forgot-pwd-wrapper h6.resend-otp-text-btn {
  margin-bottom: 22px;
  color: var(--secondary);
}
</style>
